/**
 * description: 描述信息
 * author: bql
 * 2023/8/21 15:20
 */
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";
export class EmployeeEducationApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'employee-education'
    }

}
 